import axios from "axios";
import {
  GET_ALL_MANUFACTURERS,
  GET_ALL_MANUFACTURERS_UPDATED,
  GET_ALL_MANUFACTURERS_PAGE,
  ALL_MANUFACTURERS_ERROR,
  GET_MANUFACTURER,
  GET_MANUFACTURER_ERROR,
  SELECT_MANUFACTURER,
  SEARCH_MANUFACTURERS,
  SEARCH_PUBLISHED_MANUFACTURERS,
  SEARCH_PUBLISHED_MANUFACTURERS_ERROR,
  SEARCH_MANUFACTURERS_COUNT,
  SEARCH_MANUFACTURERS_ERROR,
  GET_MANUFACTURER_COUNT,
  GET_MANUFACTURER_COUNT_ERROR,
  GET_MANUFACTURERS_AD,
  ADD_MANUFACTURER,
  ADD_MANUFACTURER_ERROR,
  UPDATE_MANUFACTURER,
  DELETE_MANUFACTURER,
  UPDATE_MANUFACTURER_ERROR,
  DELETE_MANUFACTURER_ERROR,
  GET_MANUFACTURERS_AD_ERROR,
  GET_ALL_MANUFACTURERS_PAGE_ERROR,
  UPDATE_MANUFACTURER_TAGS,
  UPDATE_MANUFACTURER_TAG_ERROR,
  GET_MANUFACTURERS_BY_CATEGORY,
  GET_MANUFACTURERS_BY_CATEGORY_ERROR,
  GET_MANUFACTURERS_AD_COUNT,
  GET_MANUFACTURERS_AD_COUNT_ERROR,
  GET_ALL_MANUFACTURERS_WITH_ADS,
  GET_ALL_MANUFACTURERS_WITH_ADS_ERROR,
  GET_ALL_MANUFACTURERS_WITH_REVIEWS,
  GET_ALL_MANUFACTURERS_WITH_REVIEWS_ERROR,
  GET_ALL_MANUFACTURERS_WITH_PRODUCT_REVIEWS,
  GET_ALL_MANUFACTURERS_WITH_PRODUCT_REVIEWS_ERROR,
} from "./types";
import { setAlert } from "./alerts";

const baseUrl = process.env.REACT_APP_BASE_URL;
const dlBaseUrl = process.env.REACT_APP_DL_BASE_URL;
const dxpBaseUrl = process.env.REACT_APP_DXP_BASE_URL;

//gets all manufacturers
export const getManufacturers = () => async (dispatch) => {
  try {
    const response = await axios.get(`${baseUrl}/api/manufacturers`);

    dispatch({
      type: GET_ALL_MANUFACTURERS,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: ALL_MANUFACTURERS_ERROR,
      payload: { msg: "Could not fetch all manufacturers" },
    });
  }
};

//gets all manufacturers
export const getManufacturersPublished = () => async (dispatch) => {
  try {
    const response = await axios.get(`${baseUrl}/api/manufacturers/published`);

    dispatch({
      type: GET_ALL_MANUFACTURERS,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: ALL_MANUFACTURERS_ERROR,
      payload: { msg: "Could not fetch all published manufacturers" },
    });
  }
};




// GET - ALL MANUFACTURERS WITH ADS
// GET - ALL MANUFACTURERS WITH ADS
// GET - ALL MANUFACTURERS WITH ADS
export const getManufacturersWithAds = () => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/manufacturers/has-ads`);

        dispatch({
        type: GET_ALL_MANUFACTURERS_WITH_ADS,
        payload: response.data,
        });
    } catch (err) {
        dispatch({
        type: GET_ALL_MANUFACTURERS_WITH_ADS_ERROR,
        payload: { msg: "Could not fetch all published manufacturers" },
        });
    }
};
// GET - ALL MANUFACTURERS WITH REVIEWS
// GET - ALL MANUFACTURERS WITH REVIEWS
// GET - ALL MANUFACTURERS WITH REVIEWS
export const getManufacturersWithReviews = () => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/manufacturers/has-reviews`);
    
        dispatch({
            type: GET_ALL_MANUFACTURERS_WITH_REVIEWS,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_ALL_MANUFACTURERS_WITH_REVIEWS_ERROR,
            payload: { msg: "Could not fetch all manufacturers with reviews" },
        });
    }
};
// GET - ALL MANUFACTURERS INLCUDING PRODUCT WITH REVIEWS
// GET - ALL MANUFACTURERS INLCUDING PRODUCT WITH REVIEWS
// GET - ALL MANUFACTURERS INLCUDING PRODUCT WITH REVIEWS
export const getManufacturersWithProductReviews = () => async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}/api/manufacturers/new/has-product-reviews`);
    
        dispatch({
            type: GET_ALL_MANUFACTURERS_WITH_PRODUCT_REVIEWS,
            payload: response.data,
        });
    } catch (err) {
        dispatch({
            type: GET_ALL_MANUFACTURERS_WITH_PRODUCT_REVIEWS_ERROR,
            payload: { msg: "Could not fetch all manufacturers with productreviews" },
        });
    }
};


//gets all updated manufacturers
export const getManufacturersUpdated = () => async (dispatch) => {
  try {
    const response = await axios.get(`${baseUrl}/api/manufacturers/recent`);

    dispatch({
      type: GET_ALL_MANUFACTURERS_UPDATED,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: ALL_MANUFACTURERS_ERROR,
      payload: { msg: "Could not fetch all manufacturers" },
    });
  }
};

//gets the total count of manufacturers
export const getManufacturerCount = () => async (dispatch) => {
  try {
    const response = await axios.get(`${baseUrl}/api/manufacturers/count`);

    dispatch({
      type: GET_MANUFACTURER_COUNT,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: GET_MANUFACTURER_COUNT_ERROR,
      payload: { msg: "Could not fetch the manufacturer count" },
    });
  }
};

//gets the total count of manufacturers
export const getAIOptimizedManufacturerCount = (aiOptimized) => async (dispatch) => {
  try {
    const response = await axios.get(`${baseUrl}/api/manufacturers/count/${aiOptimized}`);

    dispatch({
      type: GET_MANUFACTURER_COUNT,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: GET_MANUFACTURER_COUNT_ERROR,
      payload: { msg: "Could not fetch the manufacturer count" },
    });
  }
};

//gets all manufacturers paginated
export const getManufacturersPage = (page, newestFilter) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/manufacturers/modified/page/${page}/${newestFilter}/15`
    );

    dispatch({
      type: GET_ALL_MANUFACTURERS_PAGE,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: GET_ALL_MANUFACTURERS_PAGE_ERROR,
      payload: { msg: "Could not fetch all manufacturers" },
    });
  }
};

//gets all manufacturers paginated
export const getAIOptimizedManufacturersPage = (page, newestFilter, aiOptimized) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/manufacturers/modified/page/${page}/${newestFilter}/${aiOptimized}/15`
    );

    dispatch({
      type: GET_ALL_MANUFACTURERS_PAGE,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: GET_ALL_MANUFACTURERS_PAGE_ERROR,
      payload: { msg: "Could not fetch all manufacturers" },
    });
  }
};

//gets all manufacturers with ads
export const getManufacturersAds = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/manufacturers/advertisements`
    );

    dispatch({
      type: GET_MANUFACTURERS_AD,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: GET_MANUFACTURERS_AD_ERROR,
      payload: { msg: "Could not fetch all manufacturers with ads" },
    });
  }
};

//gets all manufacturers with ads
export const getManufacturersWithAdsPaginated = ({term, page, pageSize = 15, sortFilter, manufacturerFilter}) => async (dispatch) => {
  try {
    const response = await axios.put(
      `${baseUrl}/api/manufacturers/advertisements/paginated`,
      {
        term,
        page, 
        pageSize, 
        sortFilter, 
        manufacturerFilter
      }
    );
    
    dispatch({
      type: GET_MANUFACTURERS_AD,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: GET_MANUFACTURERS_AD_ERROR,
      payload: { msg: "Could not fetch all manufacturers with ads" },
    });
  }
};

//gets all manufacturers with ads
export const getManufacturersAdsCount = ({term, manufacturerFilter}) => async (dispatch) => {
  try {
    const response = await axios.put(
      `${baseUrl}/api/manufacturers/advertisements/paginated/count`,
      {
        term,
        manufacturerFilter
      }
    );
    
    dispatch({
      type: GET_MANUFACTURER_COUNT,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: GET_MANUFACTURER_COUNT,
      payload: { msg: "Could not fetch all manufacturers with ads" },
    });
  }
};

//gets manufacturer by id
export const getManufacturer = (id) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/manufacturers/manufacturer/${id}`
    );

    dispatch({
      type: GET_MANUFACTURER,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: GET_MANUFACTURER_ERROR,
      payload: { msg: "Could not fetch manufacturer" },
    });
  }
};

//gets manufacturer by id with published products
export const getManufacturer2 = (id) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/manufacturers/publishedmanufacturer/${id}`
    );
    
    dispatch({
      type: GET_MANUFACTURER,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: GET_MANUFACTURER_ERROR,
      payload: { msg: "Could not fetch manufacturer" },
    });
  }
};

//gets manufacturer by id with published products
export const getManufacturersByCategory = (id) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/manufacturers/category/${id}`
    );
    dispatch({
      type: GET_MANUFACTURERS_BY_CATEGORY,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: GET_MANUFACTURERS_BY_CATEGORY_ERROR,
      payload: { msg: "Could not fetch manufacturer" },
    });
  }
};

//gets manufacturer by id with published products
export const getAllManufacturers = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/manufacturers/category/all`
    );
    dispatch({
      type: GET_MANUFACTURERS_BY_CATEGORY,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: GET_MANUFACTURERS_BY_CATEGORY_ERROR,
      payload: { msg: "Could not fetch manufacturer" },
    });
  }
};

//Add new manufacturer
export const addManufacturer = (manufacturer, page, search, sortFilter, aiFilter) => async (dispatch) => {
  try {
    const response = await axios.post(`${baseUrl}/api/manufacturers/`, {
      manufacturer,
    });

    dispatch({
      type: ADD_MANUFACTURER,
      payload: response.data,
    });
    dispatch(setAlert("Manufacturer successfully added!", "success"));

    if (search) {
      if (aiFilter) {
        dispatch(searchAiOptimizedManufacturersPaginated(search, page, sortFilter, aiFilter));
      } else {
        dispatch(searchManufacturersPaginated(search, page, sortFilter));
      }
    } else {

      if (aiFilter) {
        dispatch(getAIOptimizedManufacturersPage(page, sortFilter, aiFilter))
      } else {
        dispatch(getManufacturersPage(page, sortFilter));
      
      }

    }
  } catch (err) {
    dispatch(setAlert("Could not add manufacturer", "danger"));
    dispatch({
      type: ADD_MANUFACTURER_ERROR,
      payload: { msg: "Could not add manufacturer" },
    });
  }
};

//update manufacturer by id
export const updateManufacturer = (id, manufacturer, page, search, sortFilter, aiFilter, aiOptimizationChanged) => async (
  dispatch
) => {
  try {
    const response = await axios.put(`${baseUrl}/api/manufacturers/${id}`, {
      manufacturer,
    });

    if (manufacturer.published === false) {
      const unpublishRelatedProducts = await axios.put(`${baseUrl}/api/products/manufacturer-cascade/${id}`);
    }

    dispatch({
      type: UPDATE_MANUFACTURER,
      payload: response.data,
    });

    dispatch(setAlert("Manufacturer successfully updated!", "success"));
    if (search) {
      if (aiFilter) {
        dispatch(searchAiOptimizedManufacturersPaginated(search, page, sortFilter, aiFilter));
      } else {
        dispatch(searchManufacturersPaginated(search, page, sortFilter));
      }
    } else {

      if (aiFilter) {
        dispatch(getAIOptimizedManufacturersPage(page, sortFilter, aiFilter))
      } else {
        dispatch(getManufacturersPage(page, sortFilter));
      
      }

    }
    
    if (aiOptimizationChanged) {
      await axios.put(`${dlBaseUrl}/api/manufacturer/ai-optimization/${id}`, { ai_optimization_enabled: manufacturer.ai_optimization_enabled })
      await axios.put(`${dxpBaseUrl}/api/manufacturers/ai-optimization/${id}`, { ai_optimization_enabled: manufacturer.ai_optimization_enabled })
    }

  } catch (err) {
    dispatch(setAlert("Could not update manufacturer", "danger"));
    dispatch({
      type: UPDATE_MANUFACTURER_ERROR,
      payload: { msg: "Could not update manufacturer" },
    });
  }
};

//update manufacturer by id for Tags
export const updateManufacturerTag = (id, manufacturer) => async (dispatch) => {
  try {
    const response = await axios.put(`${baseUrl}/api/manufacturers/${id}`, {
      manufacturer,
    });

    dispatch({
      type: UPDATE_MANUFACTURER_TAGS,
      payload: response.data,
    });

    dispatch(setAlert("Manufacturer successfully updated!", "success"));
    dispatch(getManufacturersUpdated());
  } catch (err) {
    dispatch(setAlert("Could not update manufacturer", "danger"));
    dispatch({
      type: UPDATE_MANUFACTURER_TAG_ERROR,
      payload: { msg: "Could not update manufacturer" },
    });
  }
};

//delete manufacturer by id
export const deleteManufacturer = (id, page, search, sortFilter, aiFilter) => async (dispatch) => {
  try {
    const response = await axios.delete(`${baseUrl}/api/manufacturers/${id}`);

    dispatch({
      type: DELETE_MANUFACTURER,
      payload: response.data,
    });
    dispatch(setAlert("Manufacturer successfully deleted!", "success"));

    if (search) {
      if (aiFilter) {
        dispatch(searchAiOptimizedManufacturersPaginated(search, page, sortFilter, aiFilter));
      } else {
        dispatch(searchManufacturersPaginated(search, page, sortFilter));
      }
    } else {

      if (aiFilter) {
        dispatch(getAIOptimizedManufacturersPage(page, sortFilter, aiFilter))
      } else {
        dispatch(getManufacturersPage(page, sortFilter));
      
      }

    }
  } catch (err) {
    dispatch(setAlert("Could not delete manufacturer", "danger"));
    dispatch({
      type: DELETE_MANUFACTURER_ERROR,
      payload: { msg: "Could not delete manufacturer" },
    });
  }
};

//search manufactueres
export const searchManufacturers = (manufacturer, page) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/manufacturers/manufacturersearchpage/${manufacturer}/${page}/15`
    );
    dispatch({
      type: SEARCH_MANUFACTURERS,
      payload: response.data?.rows,
    });
    dispatch({
      type: SEARCH_MANUFACTURERS_COUNT,
      payload: response.data?.count,
    });
  } catch (err) {
    dispatch({
      type: SEARCH_MANUFACTURERS_ERROR,
      payload: [],
    });
  }

  // }
};

//search manufactueres
export const searchManufacturersPaginated = (manufacturer, page, sortFilter) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/manufacturers/modified/manufacturersearchpage/${manufacturer}/${page}/15/${sortFilter}`
    );
    dispatch({
      type: GET_ALL_MANUFACTURERS_PAGE,
      payload: response.data?.rows,
    });
    dispatch({
      type: SEARCH_MANUFACTURERS_COUNT,
      payload: response.data?.count,
    });
  } catch (err) {
    dispatch({
      type: SEARCH_MANUFACTURERS_ERROR,
      payload: [],
    });
  }

  // }
};

//search manufactueres
export const searchAiOptimizedManufacturersPaginated = (manufacturer, page, sortFilter, aiOptimized) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/manufacturers/modified/manufacturersearchpage/${manufacturer}/${page}/15/${sortFilter}/${aiOptimized}`
    );
    dispatch({
      type: GET_ALL_MANUFACTURERS_PAGE,
      payload: response.data?.rows,
    });
    dispatch({
      type: SEARCH_MANUFACTURERS_COUNT,
      payload: response.data?.count,
    });
  } catch (err) {
    dispatch({
      type: SEARCH_MANUFACTURERS_ERROR,
      payload: [],
    });
  }

  // }
};

//search manufactueres
export const searchPublishedManufacturers = (manufacturer) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/manufacturers/manufacturersearchpublished/${manufacturer}`
    );

    dispatch({
      type: SEARCH_PUBLISHED_MANUFACTURERS,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: SEARCH_PUBLISHED_MANUFACTURERS_ERROR,
      payload: [],
    });
  }

  // }
};

//selects a single manufacturer
export const selectManufacturer = (manufacturer) => (dispatch) => {
  dispatch({
    type: SELECT_MANUFACTURER,
    payload: manufacturer,
  });
};
